export const GET_COMPANY_QUERY_KEY = ['myCompanyCategories'] as const;
